export default __webpack_public_path__ + "static/media/edit.a776b6d8.png";